import React from "react";

export const IconBlocks = () => {
    return (
        <svg
            width="40"
            height="41"
            viewBox="0 0 40 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M33.75 8.16669H6.25C5.58696 8.16669 4.95107 8.43008 4.48223 8.89892C4.01339 9.36776 3.75 10.0036 3.75 10.6667V30.6667C3.75 31.3297 4.01339 31.9656 4.48223 32.4345C4.95107 32.9033 5.58696 33.1667 6.25 33.1667H33.75C34.413 33.1667 35.0489 32.9033 35.5178 32.4345C35.9866 31.9656 36.25 31.3297 36.25 30.6667V10.6667C36.25 10.0036 35.9866 9.36776 35.5178 8.89892C35.0489 8.43008 34.413 8.16669 33.75 8.16669ZM6.25 10.6667H33.75V19.4167H21.25C20.9185 19.4167 20.6005 19.5484 20.3661 19.7828C20.1317 20.0172 20 20.3352 20 20.6667V30.6667H6.25V10.6667ZM33.75 30.6667H22.5V21.9167H33.75V30.6667Z"
                fill="#08212D"
            />
        </svg>
    );
};
